import { lazy } from "react";

export const LandingFirstScreenAsync = lazy(() => import("./LandingFirstScreen"));
